module.exports = __webpack_public_path__ + "static/media/block-right.acee6a81.png";